import React, {useState} from "react";
import {Link} from "react-router-dom";
import CheckboxGreen from "../assets/checkbox-green.svg";
import CheckboxBlue from "../assets/checkbox-blue.svg";
import CheckboxPurple from "../assets/checkbox-purple.svg";
import GreenDiamond from "../assets/pricing-green-icon.svg";
import BlueDiamond from "../assets/pricing-blue-icon.svg";
import PurpleDiamond from "../assets/pricing-purple-icon.svg";

import "./Prices.css";

function Prices() {
    const [annualy, setAnnually] = useState(true);

    return (
        <div style={{width: "100%"}}>
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 0 80px",
            }}>
                <div className="toggle-btn-container">
                    <p>Monthly</p>
                    <label className={annualy ? "switch switch-off" : "switch"}>
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={annualy}
                            onChange={() => setAnnually(!annualy)}
                        />
                        <div className="slider"></div>
                    </label>
                    <p>
                        Annual
                    </p>
                </div>

                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: annualy ? "#22c55e" : "transparent",
                    borderRadius: "5px",
                    border: `1px solid ${annualy ? '#22c55e' : 'transparent'}`,
                    color: "white",
                    width: "80px",
                    height: "20px",
                    fontSize: "14px",
                    padding: "0 4px",
                    marginTop: "5px",
                    marginBottom: "5px",
                    marginLeft: "20px",
                }}>
                    SAVE 30%
                </div>
            </div>
            <div className="pricing-categories">
                <article className="pricing-basic">
                    <div className="pricing-category-container">
                        <img src={GreenDiamond} alt="green diamond icon"/>
                        <div className="pricing-category">
                            <h2>Free Trial</h2>
                        </div>
                    </div>
                    <div className="pricing-category-body">
                        <p>
                            Try it for free and see what plan works best for your business.
                        </p>
                    </div>
                    <div className="pricing-category-price">
                        <span className="price">Free</span>
                    </div>
                    <div className="pricing-list-container">
                        <h3>What’s included</h3>
                        <ul className="list-included">
                            <div className="list-included-details">
                                <img src={CheckboxGreen} alt="green checkbox"/>
                                <li>Unlimited users</li>
                            </div>
                            <div className="list-included-details">
                                <img src={CheckboxGreen} alt="green checkbox"/>
                                <li>1 Data Source</li>
                            </div>
                            <div className="list-included-details">
                                <img src={CheckboxGreen} alt="green checkbox"/>
                                <li>All Magic AI Products</li>
                            </div>
                            <div className="list-included-details">
                                <img src={CheckboxGreen} alt="green checkbox"/>
                                <li>One month of feedback pieces*</li>
                            </div>
                        </ul>
                    </div>
                    <div className="contact-pricing-btn">
                        <a href="/schedule-demo">Book Demo</a>
                    </div>
                </article>
                <article className="pricing-pro">
                    <div className="pricing-category-container">
                        <img src={BlueDiamond} alt="blue diamond icon"/>
                        <div className="pricing-category">
                            <h2>Essentials</h2>
                        </div>
                    </div>
                    <div className="pricing-category-body">
                        <p>
                            Collect and analyze high quality customer feedback at scale.
                        </p>
                    </div>
                    <div className="pricing-category-price">
                        {!annualy ? (
                            <p><span className="price">€649</span>/monthly</p>
                        ) : (
                            <p><span className="price">€499</span>/monthly</p>
                        )}
                    </div>
                    <div className="pricing-list-container">
                        <h3>What’s included</h3>
                        <ul className="list-included">
                            <div className="list-included-details">
                                <img src={CheckboxBlue} alt="blue checkbox"/>
                                <li>Unlimited users</li>
                            </div>
                            <div className="list-included-details">
                                <img src={CheckboxBlue} alt="blue checkbox"/>
                                <li>Unlimited Data Sources</li>
                            </div>
                            <div className="list-included-details">
                                <img src={CheckboxBlue} alt="blue checkbox"/>
                                <li>All Magic AI Products</li>
                            </div>
                            <div className="list-included-details">
                                <img src={CheckboxBlue} alt="blue checkbox"/>
                                <li>Up to 1,000 Feedback pieces/month*</li>
                            </div>
                        </ul>
                    </div>
                    <div className="contact-pricing-btn">
                        <a href="/schedule-demo">Book Demo</a>
                    </div>
                </article>
                <article className="pricing-enterprise">
                    <div className="pricing-category-container">
                        <img src={PurpleDiamond} alt="purple diamond icon"/>
                        <div className="pricing-category">
                            <h2>Business</h2>
                        </div>
                    </div>
                    <div className="pricing-category-body">
                        <p>
                            Empower a team culture of customer obsession to build products customers love.
                        </p>
                    </div>
                    <div className="pricing-category-price">
                        <p>
                            <span className="price">Let's talk</span>
                        </p>
                    </div>
                    <div className="pricing-list-container">
                        <h3>What’s included</h3>
                        <ul className="list-included">
                            <div className="list-included-details">
                                <img
                                    src={CheckboxPurple}
                                    alt="purple checkbox"
                                />
                                <li>Unlimited users</li>
                            </div>
                            <div className="list-included-details">
                                <img
                                    src={CheckboxPurple}
                                    alt="purple checkbox"
                                />
                                <li>Unlimited Data Sources</li>
                            </div>
                            <div className="list-included-details">
                                <img
                                    src={CheckboxPurple}
                                    alt="purple checkbox"
                                />
                                <li>All Magic AI Products</li>
                            </div>
                            <div className="list-included-details">
                                <img
                                    src={CheckboxPurple}
                                    alt="purple checkbox"
                                />
                                <li>
                                    Unlimited Feedback pieces*
                                </li>
                            </div>
                            <div className="list-included-details">
                                <img
                                    src={CheckboxPurple}
                                    alt="purple checkbox"
                                />
                                <li>
                                    Unlimited data backfill
                                </li>
                            </div>
                        </ul>
                    </div>
                    <div className="contact-pricing-btn">
                        <a href="/schedule-demo">Book Demo</a>
                    </div>
                </article>
            </div>
        </div>
    );
}

export default Prices;
